module.exports = __webpack_public_path__ + "static/media/gen-01.b9a45973.png";